<template>
  <div class="search-wrapper">
    <search-header ref="header" :keyword="keywords" :search-type="activeTab"></search-header>

    <div class="search-tabs">
      <button
        type="button"
        :class="{ active: activeTab === 'products' }"
        @click="setActiveTab('products')"
      >Products</button>
      <button
        type="button"
        :class="{ active: activeTab === 'suppliers' }"
        @click="setActiveTab('suppliers')"
      >Suppliers</button>
    </div>

    <div class="search-body">
    <div class="list current-search" v-if="currenKeywords.length > 0">
        <div class="list-header">
          <span>Recent Searches</span>
          <button class="delete-btn" type="button" @click="deleteCurrent()">
            <img src="../../../assets/image/home/home-search-delete1.png">
          </button>
        </div>
        <ul class="keyword-list">
          <li class="item" v-for="(item, index) in currenKeywords" @click="getKey(item)" :key="index">{{item}}</li>
        </ul>
      </div>

      <div class="ranking-header">
        <span>Recommended Rankings</span>
      </div>

      <div class="ranking-list product-ranking-list" v-if="activeTab === 'products'">
        <div class="ranking-card" v-if="productItems.length">
          <div class="ranking-items">
            <div
              class="ranking-item"
              v-for="item in productItems"
              :key="item.key"
              @click="goRankingItem(item, 'products')"
            >
              <div class="ranking-photo">
                <img :src="item.image">
              </div>
              <div class="demand-badge" v-if="item.name">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="ranking-list" v-else>
        <div class="ranking-card supplier-card">
          <div class="ranking-items">
            <div
              class="ranking-item"
              v-for="item in supplierItems"
              :key="item.key"
              @click="goRankingItem(item, 'suppliers')"
            >
              <div class="ranking-photo supplier-photo">
                <img :src="item.image">
                <span class="supplier-logo"><img :src="item.logo"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import searchHeader from './SearchHeader'
import { searchKeywordList, searchGoodsList, getStoreList } from '../../../api/homesearch'
import noImage from '../../../assets/image/no_image.jpg'

export default {
  data () {
    return {
      hotKeywords: [],
      currenKeywords: this.$route.query.type === 'suppliers'
        ? this.utils.fetch('store_search_history')
        : [],
      keywords: (this.$route.params.isFromHome || this.$route.query.fromHome)
        ? ''
        : (this.$store.state.homesearch.currentKey ? this.$store.state.homesearch.currentKey : ''),
      activeTab: this.$route.query.type === 'suppliers' ? 'suppliers' : 'products',
      productRanking: [],
      supplierRanking: []
    }
  },
  components: {
    searchHeader
  },
  computed: {
    ...mapState({
      currentKey: state => state.homesearch.currentKey,
      token: state => state.member.token
    }),
    productItems () {
      return this.productRanking.map((item, index) => this.buildRankingItem(item, 'products', 0, 0, index))
    },
    supplierItems () {
      return this.supplierRanking.map((item, index) => this.buildRankingItem(item, 'suppliers', 0, 0, index))
    }
  },
  created () {
    if (this.$route.params.isFromHome || this.$route.query.fromHome) {
      this.changeKey('')
    }
    this.getHotKeywords()
    this.getCurrentKey()
    this.getRankings()
  },
  methods: {
    ...mapMutations({
      'changeKey': 'changeKey'
    }),
    getHotKeywords () {
      searchKeywordList().then(res => {
        this.hotKeywords = res.result && res.result.list ? res.result.list : []
      }).catch(() => {
        this.hotKeywords = []
      })
    },
    getRankings () {
      this.getProductRanking()
      this.getSupplierRanking()
    },
    getProductRanking () {
      searchGoodsList({
        page: 1,
        sort_key: 'goods_salenum',
        keyword: ''
      }, this.token).then(res => {
        this.productRanking = res.result && res.result.goods_list ? res.result.goods_list : []
      }).catch(() => {
        this.productRanking = []
      })
    },
    getSupplierRanking () {
      let pages = [1, 2, 3, 4, 5]
      Promise.all(pages.map(page => getStoreList('', '', '', 0, 0, 'store_sales', page, this.token).catch(() => null)))
        .then(responses => {
          let stores = []
          responses.forEach(res => {
            if (res && res.result && res.result.store_list) {
              stores = stores.concat(res.result.store_list)
            }
          })
          this.supplierRanking = stores
            .filter(store => store.goods_list && store.goods_list.length > 0)
            .slice(0, 50)
        })
        .catch(() => {
          this.supplierRanking = []
        })
    },
    buildRankingItem (item, type, demand, sectionIndex, itemIndex) {
      if (!item) {
        return {
          key: 'default-' + type + '-' + sectionIndex + '-' + itemIndex,
          id: '',
          image: noImage,
          logo: noImage,
          demand: this.formatNumber(demand),
          name: ''
        }
      }
      return {
        key: type + '-' + (item.goods_id || item.store_id || sectionIndex + '-' + itemIndex),
        id: item.goods_id || item.store_id || '',
        image: this.getItemImage(item, type),
        logo: item.store_avatar || noImage,
        demand: this.formatNumber(this.getDemandValue(item, type, demand)),
        name: item.goods_name || ''
      }
    },
    getItemImage (item, type) {
      if (type === 'suppliers') {
        let firstGoods = item.goods_list && item.goods_list.length ? item.goods_list[0] : null
        return (firstGoods && (
          firstGoods.goods_image_url ||
          firstGoods.goods_img_480 ||
          firstGoods.goods_image_format
        )) || item.store_avatar || noImage
      }
      return item.goods_image_url || item.goods_img_480 || item.goods_image_format || noImage
    },
    getDemandValue (item, type, fallback) {
      let value = type === 'suppliers'
        ? (item.store_sales || item.store_collect || item.store_credit || fallback)
        : (item.goods_salenum || item.goods_click || item.goods_collect || fallback)
      value = parseInt(value, 10)
      return isNaN(value) || value <= 0 ? fallback : value
    },
    formatNumber (value) {
      value = parseInt(value, 10)
      if (isNaN(value)) {
        return '0'
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    setActiveTab (tab) {
      this.activeTab = tab
      this.currenKeywords = this.utils.fetch(tab === 'suppliers' ? 'store_search_history' : 'product_keyword') || []
    },
    getKey (item) {
      if (item.content) {
        this.keywords = item.content
      } else {
        this.keywords = item
      }
      this.changeKey(this.keywords)
      this.$refs.header.search(this.keywords)
    },
    deleteCurrent () {
      const historyKey = this.activeTab === 'suppliers' ? 'store_search_history' : 'product_keyword'
      this.utils.save(historyKey, [])
      this.currenKeywords = this.utils.fetch(historyKey)
    },
    getCurrentKey () {
      const historyKey = this.activeTab === 'suppliers' ? 'store_search_history' : 'product_keyword'
      this.currenKeywords = this.utils.fetch(historyKey)
    },
    goRankingItem (item, type) {
      if (!item.id) {
        return false
      }
      if (type === 'suppliers') {
        this.$router.push({ name: 'HomeStoredetail', query: { id: item.id } })
      } else {
        this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: item.id } })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.search-wrapper {
  min-height: 100vh;
  width: auto;
  background: #fff;
  padding-bottom: 3rem;
  box-sizing: border-box;
}
.search-tabs {
  display: flex;
  align-items: flex-end;
  height: 2.15rem;
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
}
.search-tabs button {
  position: relative;
  flex: 1;
  height: 2.15rem;
  line-height: 2.15rem;
  border: 0;
  background: transparent;
  color: #3c3c3c;
  font-size: 0.7rem;
  padding: 0;
}
.search-tabs button.active:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  width: 9.4rem;
  max-width: 100%;
  height: 0.08rem;
  margin: 0 auto;
  background: #e93b3d;
}
.search-body {
  padding: 0.65rem 0.75rem 0;
  background: #fff;
}
.list {
  margin-bottom: 1.15rem;
}
.list-header,
.ranking-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}
.list-header span,
.ranking-header span {
  color: #333;
  font-size: 0.78rem;
  line-height: 1rem;
}
.delete-btn {
  width: 1.35rem;
  height: 1.35rem;
  border: 0;
  background: transparent;
  padding: 0;
  flex-shrink: 0;
}
.delete-btn img {
  width: 1rem;
  height: 1rem;
  vertical-align: middle;
}
.keyword-list {
  display: flex;
  padding-top: 0.55rem;
  flex-wrap: wrap;
}
.keyword-list li {
  height: 1.1rem;
  line-height: 1.1rem;
  padding: 0 0.4rem;
  border-radius: 0.12rem;
  background-color: #f1f2f4;
  color: #444;
  font-size: 0.58rem;
  margin-right: 0.45rem;
  margin-bottom: 0.45rem;
  cursor: pointer;
}
.ranking-header {
  margin-bottom: 0.35rem;
}
.ranking-card {
  position: relative;
  margin-bottom: 1.35rem;
  padding-top: 0.45rem;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, #f5f5f5 100%);
  border-radius: 0.28rem;
}
.product-ranking-list .ranking-card,
.product-ranking-list .ranking-photo,
.product-ranking-list .ranking-photo img,
.product-ranking-list .demand-badge {
  border-radius: 0;
}
.ranking-items {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.45rem;
  padding: 0 0.4rem;
}
.ranking-item {
  min-width: 0;
  cursor: pointer;
}
.ranking-photo {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  border: 1px solid #e4e4e4;
  background: #fff;
  box-shadow: 0 0.04rem 0.16rem rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
}
.ranking-photo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.demand-badge {
  position: relative;
  z-index: 3;
  width: 100%;
  height: 1.02rem;
  line-height: 1.02rem;
  margin-top: -0.35rem;
  border-radius: 0.55rem;
  background: #171717;
  color: #fff;
  font-size: 0.5rem;
  font-weight: 700;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 0.3rem;
  box-sizing: border-box;
}
.ranking-info {
  position: relative;
  display: flex;
  align-items: center;
  height: 2.6rem;
  margin-top: 0.45rem;
  padding: 0 0.5rem;
  border-radius: 0.28rem;
  background: linear-gradient(90deg, #fff4bb 0%, #fff5ca 58%, #ffd985 100%);
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
}
.ranking-info:before,
.ranking-info:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1.6rem;
  transform: skewX(-32deg);
  background: rgba(255,255,255,0.34);
}
.ranking-info:before {
  right: 0.3rem;
}
.ranking-info:after {
  right: -0.55rem;
}
.ranking-info div {
  position: relative;
  z-index: 2;
  min-width: 0;
  flex: 1;
}
.ranking-info strong {
  display: block;
  color: #282828;
  font-size: 0.74rem;
  line-height: 0.88rem;
  font-weight: 700;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ranking-info span {
  display: block;
  color: #333;
  font-size: 0.56rem;
  line-height: 0.76rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ranking-info i {
  position: relative;
  z-index: 2;
  color: #9c7a34;
  font-size: 0.65rem;
  flex-shrink: 0;
}
.supplier-card {
  padding-top: 0.9rem;
}
.supplier-card .ranking-items {
  gap: 0.7rem;
}
.supplier-photo {
  aspect-ratio: 1 / 1;
}
.supplier-logo {
  position: absolute;
  left: 50%;
  bottom: -0.58rem;
  width: 1.7rem;
  height: 1.7rem;
  margin-left: -0.85rem;
  border: 1px solid #e3e3e3;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0 0.05rem 0.14rem rgba(0, 0, 0, 0.14);
}
.supplier-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
@media (min-width: 520px) {
  .search-wrapper {
    max-width: 460px;
    margin: 0 auto;
    border-left: 1px solid #ededed;
    border-right: 1px solid #ededed;
  }
}
</style>
